import styled from 'styled-components'
import { GREY_DARK, GREY_LIGHTS, RED } from '../../utils/colors'

export const ContainerStatement = styled.div`
  margin: -30px;
  margin-bottom: 126px;
`

export const Container = styled.div`
  h3 {
    margin-top: 44px;
    margin-bottom: 44px;
  }
`

export const ContainerCancelPlan = styled.div`
  .input, .select {
    margin-top: 32px;
  }
`

export const CreditCard = styled.div`
  white-space: nowrap;
  span {
    font-weight: bold;
    font-size: 18px;
    color: #001021;
    display: inline-block;
    margin-right: 12px;
  }

  .pf {
    font-size: 20px;
  }
`

export const FooterSelectPlan = styled.div`
  .info {
    font-size: 12px;
    line-height: 17px;
    color: ${GREY_DARK};
    margin-top: 47px;
  }

  .accept {
    font-family: Segoe UI;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: ${GREY_LIGHTS};
    display: flex;
    justify-content: flex-end;
    margin-top: 39px;

    img {
      display: inline-block !important;
      width: auto;
      height: 36px;
      margin-top: 6px;
      filter: invert(100%);
      opacity: 0.4;
      &:last-child {
        opacity: 0.8;
        filter: grayscale(100);
      }
    }
  }
`

export const ContainerSelectPlan = styled.div`
  h2 {
    font-family: 'Segoe UI', sans-serif;
    margin-bottom: 53px;
  }

  .half {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0px 14px;
  }
`

export const PlansContainer = styled.div`
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .cancel {
      font-weight: normal;
      font-size: 12px;
      line-height: 1.5;
      text-align: left;
      color: ${RED};
    }
  }

  h3 {
    margin-top: 44px;
    margin-bottom: 14px;

    span {
      margin-bottom: -15px;
    }
  }

  h3 span, .subtitle {
    display: block;
    font-size: 16px;
    line-height: 1.44;
    text-align: left;
    color: ${GREY_DARK};
  }

  .plan_info {
    max-width: 583px;
    font-size: 12px;
    line-height: 1.5;
    color: ${GREY_DARK};
  }

  .plans_listing {
    margin-right: -30px;
    margin-left: -30px;
    margin-bottom: 100px;
  }
`
